// Zentraler Lookup-Helfer fuer Teammitglieder.
// Kanonisch ist `employeeUuid` (UUID v4). `teamId` (RowKey) bleibt als
// temporaerer Fallback, bis alle Aufrufer migriert sind -- ein console.warn
// macht Restbestaende sichtbar.

export const findTeamMember = (teamMembers, personId) => {
  if (!personId || !Array.isArray(teamMembers)) return null;
  const byUuid = teamMembers.find((m) => m && m.employeeUuid === personId);
  if (byUuid) return byUuid;
  const byTeamId = teamMembers.find((m) => m && m.teamId === personId);
  if (byTeamId) {
    console.warn(
      `findTeamMember: personId '${personId}' ist eine teamId (RowKey). Aufrufer auf employeeUuid migrieren.`,
    );
    return byTeamId;
  }
  return null;
};

export const getTeamMemberName = (teamMembers, personId) => {
  const member = findTeamMember(teamMembers, personId);
  return member?.name || "Unbekannt (gelöscht)";
};

export const getTeamMemberInitials = (teamMembers, personId) => {
  const member = findTeamMember(teamMembers, personId);
  if (!member?.name) return "??";
  const parts = member.name.trim().split(/\s+/);
  if (parts.length >= 2) {
    return `${parts[0].charAt(0)}${parts[parts.length - 1].charAt(0)}`.toUpperCase();
  }
  return member.name.substring(0, 2).toUpperCase();
};
